import React from 'react';
import { Colors } from 'shared-react/dist/styles';

interface BitPayLogoProps {
  color?: string;
}

export const SvgPersonalIcon: React.FC<BitPayLogoProps> = ({ color = Colors.Go }) => {
  return (
    <svg width="18" height="20" viewBox="0 0 18 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M8.75 6.25C10.4759 6.25 11.875 4.85089 11.875 3.125C11.875 1.39911 10.4759 0 8.75 0C7.02411 0 5.625 1.39911 5.625 3.125C5.625 4.85089 7.02411 6.25 8.75 6.25Z" fill={color}/>
      <path d="M17.0636 11.5513L12.6886 7.80125C12.462 7.60689 12.1733 7.50003 11.8748 7.5H5.6248C5.32628 7.50003 5.03763 7.60689 4.81105 7.80125L0.436054 11.5513C0.305385 11.6634 0.199285 11.8013 0.124406 11.9563C0.0495265 12.1113 0.00748311 12.2802 0.000911047 12.4522C-0.00566102 12.6243 0.02338 12.7958 0.0862135 12.9561C0.149047 13.1164 0.244318 13.262 0.366054 13.3837L3.7498 16.7675V13.2325L3.08855 12.5712L4.9998 10.9325V18.75C4.9998 19.0815 5.1315 19.3995 5.36592 19.6339C5.60034 19.8683 5.91828 20 6.2498 20H11.2498C11.5813 20 11.8993 19.8683 12.1337 19.6339C12.3681 19.3995 12.4998 19.0815 12.4998 18.75V10.9325L14.4111 12.5712L13.7498 13.2325V16.7675L17.1336 13.3837C17.2553 13.262 17.3506 13.1164 17.4134 12.9561C17.4762 12.7958 17.5053 12.6243 17.4987 12.4522C17.4921 12.2802 17.4501 12.1113 17.3752 11.9563C17.3003 11.8013 17.1942 11.6634 17.0636 11.5513Z" fill={color}/>
    </svg>
  );
};

export default SvgPersonalIcon;
